<div>
    <div #mapcontainer style="width: 100%; position: relative">
        <rask-map [settings]="mapsettings">
            <rask-map-fastighet [hideButton]="false" [importEnabled]="true" (fastighet)="onImportingFastighet($event)">
            </rask-map-fastighet>
            <rask-map-layers></rask-map-layers>
        </rask-map>
    </div>
</div>
